const NEW_PACKAGE_ITEM_ID = 'new';

export { NEW_PACKAGE_ITEM_ID };
